import axios from 'axios'
import {API_ADMIN} from '@/utils/constants/Api'
import {UserAuthenticatedModel} from '@/user/models/UserAuthenticatedModel'
import { MuvenRoleEnum } from '@c2b/muven-commons'

interface MuvenRoleEnumWrapper {
    enum: MuvenRoleEnum;
    name: string;
    description: string;
}

export default {
    getUserAuthenticated():Promise<UserAuthenticatedModel> {
        return axios.get(`${API_ADMIN}users/authenticated`)
            .then(({data}) => {
                return new UserAuthenticatedModel(data)
            })
    },
    getUserAuthenticatedRoles():Promise<MuvenRoleEnum[]> {
        return axios.get(`${API_ADMIN}users/authenticated/roles`)
            .then(({data}) => {
                return data
            })
    },
    getUserRoles():Promise<MuvenRoleEnumWrapper[]> {
        return axios.get(`${API_ADMIN}users/roles`)
            .then(({data}) => {
                return data
            })
    },
    updateInfo(user: UserAuthenticatedModel):Promise<any> {
        return axios.put(`${API_ADMIN}users/authenticated`, user)
            .then(({data}) => {
                return data
            })
    },
}
